import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { ReportsPage } from '../../../features/reports/components/ReportsPage.tsx';

const searchSchema = z.object({
  year: z.coerce.number().int().min(2000).max(2100).optional(),
});

export const Route = createFileRoute('/_authed/reports/')({
  validateSearch: (s) => searchSchema.parse(s),
  component: ReportsRoute,
});

function ReportsRoute() {
  const navigate = useNavigate();
  const { year } = Route.useSearch();

  function handleYearChange(newYear: number) {
    void navigate({
      to: '/reports',
      search: { year: newYear },
      replace: true,
    });
  }

  return (
    <div className="flex-1 overflow-auto px-3 sm:px-6 py-4 sm:py-6">
      <ReportsPage initialYear={year} onYearChange={handleYearChange} />
    </div>
  );
}
